// Copyright (c) 2015, Orbit7 Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

// provide a namespace
if (!window.orbit7) window.orbit7 = {};

orbit7.provide = function (namespace) {
	// docs: create a namespace //
	var nsl = namespace.split(".");
	var parent = window;
	for (var i = 0; i < nsl.length; i++) {
		var n = nsl[i];
		if (!parent[n]) {
			parent[n] = {};
		}
		parent = parent[n];
	}
	return parent;
};

orbit7.provide("locals");
orbit7.provide("orbit7.flags");
orbit7.provide("orbit7.settings");
orbit7.provide("orbit7.utils");
orbit7.provide("orbit7.ui.form");
orbit7.provide("orbit7.modules");
orbit7.provide("orbit7.templates");
orbit7.provide("orbit7.test_data");
orbit7.provide("orbit7.utils");
orbit7.provide("orbit7.model");
orbit7.provide("orbit7.user");
orbit7.provide("orbit7.session");
orbit7.provide("orbit7._messages");
orbit7.provide("locals.DocType");

// for listviews
orbit7.provide("orbit7.listview_settings");
orbit7.provide("orbit7.tour");
orbit7.provide("orbit7.listview_parent_route");

// constants
window.NEWLINE = "\n";
window.TAB = 9;
window.UP_ARROW = 38;
window.DOWN_ARROW = 40;

// proxy for user globals defined in desk.js

// API globals
window.cur_frm = null;
